import { render } from "./CategoryHeader.vue?vue&type=template&id=d4b71150"
import script from "./CategoryHeader.vue?vue&type=script&lang=js"
export * from "./CategoryHeader.vue?vue&type=script&lang=js"

import "./CategoryHeader.vue?vue&type=style&index=0&id=d4b71150&lang=css"

import exportComponent from "/Users/learnbody/Documents/VSWorkspaces/learnbody-market-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__